<template>
    <div v-show="isShow" :style="domStyle">
        <div ref="histogram" :style="domStyles"></div>
        <div v-if="isEnable" :style="enableStyle"></div>
    </div>
</template>
<script>
export default {
    name : "fvHistogram",
    props : ["primitives","fvSystemApi","parentObject"],
    created (){
        //窗口边框宽度。计算图元和组件位置时需要
        this.defaultTailoring = this.parentObject.defaultTailoring;
        //窗口大小
        this.windowSize = this.parentObject.windowSize;
        //创建组件
        this.create();
        //父组件（可能是窗口也可能是组）vuex数据模型路径数组
        this.modelsPath = this.parentObject.modelsPath.slice(0);
        //创建本省的vuex数据模型
        this.modelsPath.push(this.registerName);
        this.$store.registerModule(this.modelsPath,{
            state : {
                $ : this
            }
        });
    },
    data (){
        return {
            //是否可用
            isEnable : false,
            //是否显示
            isShow : true,
            //组件大小位置,在created(创建完毕，挂载前)函数中初始化
            domStyle : {},
            xData:[],
            hisStep:0,
            startTimeOut:false,
            endTimeOut:false,
            option: {},
            //数据保留的小数位数
            decimal: 2
        }
    },
    watch: {
        
    },
    mounted(){
        // 基于准备好的dom，初始化echarts实例
        var histogramDom = this.$refs.histogram;
        this.myChart = this.$echarts.init(histogramDom);
        this.getData();
    },
    methods : {
        create(){
            this.mixin(this.primitives);
           //组件大小位置初始化
            this.domStyle = {
                position : "absolute",
                left : 0 + "px",
                top : 0 + "px",
                width : 0 + "px",
                height : 0 + "px",
                textAlign : 'center',
                lineHeight : this.height + "px",
            }
            this.domStyles = {
                width : 0 + "px",
                height : 0 + "px",
                textAlign : 'center',
                lineHeight : this.height + "px",
            }
            this.enableStyle = {
                position: "absolute",
                width: "100%",
                height: "100%",
                top: "0px",
                backgroundColor: "#ccbfbf",
                opacity: "0.5"
            }
        },
        //混入属性
        mixin(src) {
            for (var key in src) {
                this[key] = src[key]
            }
        },
        /*
            参数：scaleObj 重绘信息
            作用：组件需要重绘时触发
        */
        reDraw(scaleObj){
            this.scaleObj = scaleObj;
            if(this.fontSize){
                this.domStyle.fontSize = parseInt(parseInt(this.fontSize.substr(0, this.fontSize.length - 2)) * (scaleObj.sy + scaleObj.zoom) + scaleObj.oy) + "px"; 
            }
            this.domStyle.left = parseInt((this.x * (scaleObj.sx + scaleObj.zoom)) + scaleObj.ox) + "px";
            //弹出窗top位置计算
            if(this.$parent.fctype != "fvGroupObj"){
                this.domStyle.top  = parseInt(((this.y)* (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy)+this.$el.parentElement.offsetTop+1 + "px";
            }else{
                this.domStyle.top  = parseInt(((this.y)* (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy) + this.parentObject.heightTitle + "px";
            }
            this.domStyle.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
            this.domStyle.height = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px"; 

            this.domStyles.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
            this.domStyles.height = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px"; 
            
            this.$refs.histogram.style.width = this.domStyle.width;
            this.$refs.histogram.style.height = this.domStyle.height;
            this.myChart.resize();
        }, 
        /*
        *多语言
        */ 
        setHistogramTitle() {
            var resText = this.fvSystemApi.getResource(this.title) || this.title;
            if(this.option.title.text != resText){
                this.option.title.text = resText ? resText : this.title;
                this.myChart.setOption({
                    title : {
                        text : this.option.title.text
                    }
                });;
            };
        },
        /*
            参数：e 鼠标信息
                 domScale 窗口放大、缩小、偏移等信息
            作用：鼠标事件调用函数，无必要可不进行任何处理
        */
        doFixedEvent(){

        },
        /*
            参数：无
            作用：系统周期调用
        */
        onTimer(time,flag){
           
        },
        /*
            参数：isShow 显示隐藏
            作用：设置组件整体显隐
        */
        Show(isShow){
            this.isShow = isShow ? true:false;
        },
        /*
            参数：isEnable 是否可用
            作用：设置组件是否可用
        */
        Enable : function(isEnable){
            this.isEnable = isEnable ? false : true;
        },
        // 绘制图表
        drawHistogram() {
            this.option = {
                title: {
                    text: this.title,
                    textStyle: { 
                        color: this.titleColor,
                    },
                    show: true,
                    left: this.titleLocation,
                },
                // color: this.color,
                backgroundColor: this.backgroundColor,
                tooltip: { 
                    trigger: 'item',
                    formatter: (a)=>{
                        var name = a.name.split("\n")[1] ? a.name.split("\n")[1] : a.name;
                        var seriesName = a.seriesName?a.seriesName+"<br />":'';
                        var val;
                            if(a.value==""||a.value==undefined){
                                val = 0.00;
                            }else{
                                if(a.value){
                                    val = Math.floor(a.value * Math.pow(10,2)) / Math.pow(10,2);
                                }else{
                                    val = 0.00
                                }
                            }
                        // var val = a.value ? parseFloat(a.value).toFixed(2) : parseFloat(a.value).toFixed(2);
                        return seriesName+a.marker+name+"  "+val;
                    },
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#283b56'
                        }
                    },
                    textStyle:{
                        align:'left'
                    }
                },
                legend: {
                    data: [
                    ],
                    top: "0",
                    right:'right',
                    itemWidth:12,  //图例标记的图形宽度
                    itemHeight:10, //图例标记的图形高度
                    selected:{
                    },
                },
                grid:{
                    // left:70,
                    right:50,
                },
                xAxis: [{
                    type: this.orientType == 'vertical' ? 'category' : 'value',
                    data: this.orientType == 'vertical' ? this.xData : [],
                    // name: this.xName, //名字
                    nameLocation: 'center', //坐标轴位置
                    nameTextStyle: { //坐标轴名称样式设置
                        color: this.xNameColor,
                        align: 'left',
                        padding: '10',
                    },
                    nameGap: 23,
                    axisLine: { //坐标轴轴线
                        symbol: ['none', 'arrow'], //是否带箭头
                        lineStyle: {
                            color: this.xAxisLineColor,
                            width: 1, //坐标轴线宽
                        }
                    },
                    axisLabel: {
                        show: true,
                        textStyle: {
                            color: this.xAxisLabelColor //X轴文字颜色
                        },
                    },
                    axisPointer: {
                        show: true,
                        type: 'shadow'
                    },
                }],
                yAxis: [{
                    type: this.orientType == 'horizontal' ? 'category' : 'value',
                    data: this.orientType == 'horizontal' ? this.xData : [],
                    axisLine: { //坐标轴轴线
                        symbol: ['none', 'arrow'], //是否带箭头
                      
                        lineStyle: {
                            color: this.yAxisLineColor, //坐标轴线颜色
                            width: 1, //坐标轴线宽
                        }
                    },
                    nameGap: 15,
                    grid: {
                        left: "20%"
                    },
                    axisLabel: {
                        show: true,
                        textStyle: {
                            color:this.yAxisLabelColor //X轴文字颜色
                        },
                        // margin: 2,
                        formatter: function (value, index) {
                            if (value >= 10000 && value < 10000000) {
                                value = value / 10000 + "万";
                            } else if (value >= 10000000) {
                                value = value / 10000000 + "千万";
                            }
                            return value;
                        }
                    },
                    // name: this.yName, //名字
                    nameLocation: 'center', //坐标轴位置
                    nameTextStyle: { //坐标轴名称样式设置
                        color: this.yNameColor,
                        align: 'left',
                    },
                }],
                series: []
            };
            this.setSeriesData(this.option);
            this.myChart.setOption(this.option);
            
            this.setHistogramTitle();
            window.addEventListener('resize',()=>{this.myChart.resize()});
        },
        /*作用：设置series
          参数：图表配置项
        */
        setSeriesData(option){
            var seriesData = {
                name: '每月花费a',
                type: 'bar',
                data: [],
                // barWidth:'50%',
                itemStyle:{    
                    normal: {
                        shadowColor: 'rgba(0, 0, 0, 0.5)',
                        shadowBlur: 10,
                        shadowOffsetX:10,
                    }
                },
                markPoint : {
                    data : [
                        {type : this.statisticStyle.max ? "max":'', name: '最大值'},
                        {type : this.statisticStyle.min ? "min":'', name: '最小值'}
                    ],
                },
                markLine : {
                    data : [
                        {type : 'average', name: '平均值'}
                    ],
                }
            }
            this.data.forEach((data,i)=>{
                seriesData = JSON.parse(JSON.stringify(seriesData));
                seriesData.itemStyle.normal.color = data.color;
                seriesData.data = data.value;
                seriesData.name = data.name;seriesData.name = data.name;
                option.legend.data.push({name:data.name});
                
                if(!this.statisticStyle.average){
                    seriesData.markLine = {};
                }
                option.series.push(seriesData);

            },this)
            //设置数据可视化拖动效果
            var dataZoom = [
                    {   
                        type: 'slider',
                        start: 0,
                        end: 100,
                    },
                    {
                        type: 'inside',
                        start: 0,
                        end: 100,
                    },
                ];
                //判断是横向还是纵向
            if(option.yAxis[0].data[0]){
                //设置柱状图left距离
                if(option.yAxis[0].data[0].length > 15){
                    var grid = {
                        left:130,
                    };
                }else{
                    var grid = {
                        left:70,
                    }; 
                }
            }else{
                var grid = {
                    left:70,
                }; 
            }
            if(this.orientType == "vertical"){
                dataZoom[0].xAxisIndex = [0];
                dataZoom[1].xAxisIndex = [0];
            }else{
                dataZoom[0].yAxisIndex = [0];
                dataZoom[1].yAxisIndex = [0];
                option.grid = grid;
            }
            option.dataZoom = dataZoom;
        },
        //根据点获取数据
        getData(){
            //x轴为自定义轴
            if(this.xType == "custom"){
                this.getReal();
                this.customData(this.xData);
                //请求到数据绘制柱状图
                this.drawHistogram();
                //y轴为自定义轴
            }else if(this.yType == "custom"){
                this.getReal();
                this.customData(this.yData);
                //请求到数据绘制柱状图
                this.drawHistogram();
            }else{
                var data = this.makeMessage();
                if(this.dataType != "historicalData"){
                    console.log("实时数据。");
                }else{
                    if(data){
                        this.fvSystemApi.getHistory(data).then(function (result) {
                            this.setXdata(result.varList);
                            this.parsingData(result.varList);
                            this.drawHistogram();
                        }.bind(this)).catch(function (error) {
                            if(error.error == "获取历史请求较多，请等待"){
                                setTimeout(()=>{
                                    this.getHistorydata(data);
                                },1000)
                            }else{
                                this.drawHistogram(); 
                                this.$Message.error('失败：' + error);
                            }
                        }.bind(this));
                    }
                }
            }
        },
        getHistorydata(data){
            this.fvSystemApi.getHistory(data).then(function (result) {
                this.setXdata(result.varList);
                this.parsingData(result.varList);
                this.drawHistogram();
            }.bind(this)).catch(function (error) {
                if(error.error == "获取历史请求较多，请等待"){
                    setTimeout(()=>{
                        this.getHistorydata(data);
                    },1000)
                }else{
                    this.drawHistogram(); 
                    this.$Message.error('失败：' + error);
                }
            }.bind(this));
        },
        getReal(){
            for(var i = 0; i<this.data.length; i++){
                var realData = this.fvSystemApi.getReal(this.data[i].tagName);
            }
        },
        /*
            作用：设置x轴data数据
            参数：返回历史数据
        */
        setXdata(result) {
            this.xData = [];
            if (result.length > 0 && result[0].valueList.length > 0) {
            result[0].valueList.forEach((element) => {
            //element.TIME = element.TIME.split(" ").join("\n")
            if ((typeof element.TIME == 'string') && element.TIME.constructor == String) {
              this.xData.push(this.timestampToTime(element.TIME.replace(/-/g, "/")));
            }else if(Object.prototype.toString.call(element.TIME) === '[object Number]' &&  isFinite(element.TIME)){
                this.xData.push(this.timestampToTime(element.TIME));
            }else{
                this.xData.push(this.timestampToTime(element.TIME));
            }

          })
        }
      },
        timestampToTime (timestamp) {
            var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear() + '/';
            var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '/';
            var D = date.getDate() + ' ';
            var h = date.getHours() + ':';
            var m = date.getMinutes() + ':';
            var s = date.getSeconds();
            return Y+M+D+h+m+s;
        },
        /*
            作用：解析data数据
            参数：返回历史数据
        */
        parsingData(result){
            if(result.length>0){
                this.data.forEach((obj,i)=>{
                    //当点名称相同后台返回result只显示一条，进行插入数据处理
                    // if(!result[i]||result[i].varName.replace(/\\/g,".").indexOf(this.dbVar[i])<0){
                    //      result.splice(i,0,result[i-1])
                    // }
                    obj["value"] = [];
                    result[i].valueList.forEach((element)=>{
                        //保留小数位数
                        obj["value"].push(parseFloat(element.PV).toFixed(this.decimal));
                    })
                })
            }
        },
        /*
            作用：解析data数据
            参数：返回自定义轴数据
        */
        customData(result){
            this.xData = [];
            result.forEach((e,i)=>{
                this.xData.push(e.name);
            })
        },
        //根据时间间隔设置调用历史数据参数
        makeMessage(){
            // 默认间隔是0，如果存在直接调用
            if(!this.hisStep){
                //时间间隔类型
                switch(Number(this.timeType)){
                    case 0://时
                        this.hisStep = Number(this.timeStep)*3600;
                    break;
                    case 1://分
                        this.hisStep = Number(this.timeStep)*60;
                    break;
                    case 2://秒
                        this.hisStep = Number(this.timeStep);
                    break;
                };
            };

            if(this.data.length <= 0){
                return null;
            }
            var varList = [];
            for(var i = 0; i < this.dbVar.length; i++){
                varList.push(this.dbVar[i].split("$").join(""));
            }
            if(this.dataType != "historicalData"){
                
            }else{
                var startTime = new Date(this.startTime.replace(/-/g, "/")).getTime();
                var endTime = new Date(this.endTime.replace(/-/g, "/")).getTime();
            }
            var hisType = 0;
            var hisMessage = {
                "head" : "dataLayer",
                "message" : {
                    "head": "getHisData",
                    "varList": varList,//["a.PV","b.PV"]
                    "startTime": startTime,//起始时间 Date().GetTime
                    "endTime": endTime,//时间跨度
                    "hisType": hisType,  // 0真实历史值, 1 步长历史值
                    "hisStep": this.hisStep  //步长单位秒
                }
            };
            
            return hisMessage;
        },
        /**
         * 作用：获取开始时间
         */
        GetStartTime() {
            return this.startTime;
        },
        /**
         * 作用：获取结束时间
         */
        GetEndTime() {
            return this.endTime;
        },
        /**
         * 作用：设置的结束时间
         */
        SetStartTime(dataStartTime){
           if(new Date(dataStartTime).getTime() > new Date().getTime()) {
                this.startTimeOut = true;
                this.$Message.error("开始时间以超出当前时间-"+dataStartTime +"-"+new Date());
                return;
            }   
            this.startTimeOut = false;   
            this.startTime = dataStartTime;
        },
        /**
         * 作用：设置的结束时间
         */
        SetEndTime(dataEndTime){
             if(new Date(dataEndTime).getTime() > new Date().getTime()) {
                if(this.startTimeOut == true){
                    this.endTimeOut = true;
                    this.$Message.error("结束时间以超出当前时间-"+ dataEndTime + "-" + new Date());
                }
                this.endTimeOut = false; 
                return;
            } 
            this.endTime = dataEndTime;
        },
        /**
         * 作用：获取时间间隔
         */
        GetTimeStep() {
            return this.hisStep;
        },
        /**
         * 作用：设置时间间隔
         */
        SetTimeStep: function(dataTimeStep){
            this.hisStep = dataTimeStep;
        },
        /**
            作用：更新数据
         */
        UpDateData(){
            if(this.startTimeOut || this.endTimeOut){
                return;
            }
            this.getData();
        },
    }
}
</script>
<style>
   
</style>



// WEBPACK FOOTER //
// src/components/primitives/fvHistogram/fvHistogram.vue